/**
 * @returns {import("../datagrid").Plugin}
 */
export function searchPlugin() {
  return ($container) => {
    const $searchInput = $container.querySelector(".js-datagrid-search");
    if (!$searchInput) {
      console.warn("Search input could not be found");
    }

    return {
      id: "search",
      onDataGridCreated() {
        $searchInput.addEventListener("input", (_e) => this.searchByText($searchInput.value));
      },
      onContentReady() {
        const searchPanel = this.option().searchPanel.text;
        $searchInput.value = searchPanel;
      },
    };
  };
}
